import { getValueAtPath } from "../../../../../utils";
import ViewFactory from "../../../helpers/viewfactory";
import EventLog from "../../../../../logger/events"


function chargeEnairaAccount() {
  const $this = this;
  const { $charge, $inputs } = this;

  const paymentOption = getValueAtPath($inputs, 'eNairaPaymentOption[value]');

  switch(paymentOption.identifier) {
    case 'QR': {
      $charge.init({
        data: {
          is_qr: true,
        }
      })
      break;
    }


    case 'TOKEN': {
      $charge.init({
        data: {
          is_token: true
        }
      })
      break;
    }


    case 'DIRECT_WALLET_DEBIT': {
      $charge.init()
      break;
    }
  }

  EventLog.eNairaOptionSelected(paymentOption.label)
}

export default function view() {
  // const { DATA, $charge } = this;
  const $this = this;

  return (view = ViewFactory({
    NAME: 'ENAIRA_INIT_VIEW',

    inputs: ['eNairaPaymentOption'],

    constants: { hasBackAction: false },
    next() { return chargeEnairaAccount.call($this) }
  }).call(this));
}
